"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryDrug_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrug_Factory = /** @class */ (function () {
    function SurgeryDrug_Factory() {
    }
    SurgeryDrug_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            FavoriteStatus: model.FavoriteStatus,
            Name: model.Name,
            NotUserEditable: model.NotUserEditable,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    SurgeryDrug_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            FavoriteStatus: model.FavoriteStatus,
            Name: model.Name,
            NotUserEditable: model.NotUserEditable,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return SurgeryDrug_Factory;
}());
exports.SurgeryDrug_Factory = SurgeryDrug_Factory;
